import React from 'react';

import NextImage from 'next/image';

import firstQuarter from './assets/first_quarter.svg';
import fullMoon from './assets/full_moon.svg';
import newMoon from './assets/new_moon.svg';
import thirdQuarter from './assets/third_quarter.svg';
import waningCrescent from './assets/waning_crescent.svg';
import waningGibbous from './assets/waning_gibbous.svg';
import waxingCrescent from './assets/waxing_crescent.svg';
import waxingGibbous from './assets/waxing_gibbous.svg';

const MOON_PHASE_ICONS = {
  first_quarter: firstQuarter,
  third_quarter: thirdQuarter,
  new_moon: newMoon,
  full_moon: fullMoon,
  waning_crescent: waningCrescent,
  waxing_crescent: waxingCrescent,
  waxing_gibbous: waxingGibbous,
  waning_gibbous: waningGibbous,
};

export interface IMoonPhaseIconProps extends React.SVGProps<SVGSVGElement> {
  moonPhase: keyof typeof MOON_PHASE_ICONS;
  width?: number | `${number}`;
  height?: number | `${number}`;
}

export const MoonPhaseIcon = ({ moonPhase, height = '32', width = '32' }: IMoonPhaseIconProps) => {
  const src = MOON_PHASE_ICONS[moonPhase];
  return src ? <NextImage alt="Moon Phase Icon" width={width} height={height} src={src} /> : <></>;
};
